import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "message", "reset"]
  static values = {
    placeholder: String,
  }

  connect() {
    this.storeInitialValue()
    if (this.hasPlaceholder) {
      this.toggleTextarea()
      this.resizeTextArea()
    }
  }

  resizeTextArea() {
    this.textareaTarget.style.height = 'auto'
    this.textareaTarget.style.height = (this.textareaTarget.scrollHeight + 10) + 'px'
  }

  storeInitialValue() {
    this.placeholderValue = this.textareaTarget.value
  }

  resetTextarea(event) {
    event.preventDefault()
    event.stopPropagation()
    this.textareaTarget.value = this.placeholderValue

    // Dispatch a change event
    const changeEvent = new Event('change', { bubbles: true })
    this.textareaTarget.dispatchEvent(changeEvent)
    
    // Optionally resize the textarea after reset
    this.resizeTextArea()
    this.textareaTarget.focus()
  }

  toggleTextarea() {
    const textarea = this.textareaTarget
    const message = this.messageTarget
    const reset = this.resetTarget
    textarea.hidden = !textarea.hidden
    message.hidden = !message.hidden
    reset.hidden = !reset.hidden
  }

  get hasPlaceholder() {
    const tester = /\[\[.*\]\]/
    const test = tester.test(this.textareaTarget.value)
    return test
  }
}
